import { useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ProductResponse } from '@/providers/HttpProvider/Fulfill/Inventory/types';
import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';

interface UseButtonPanelProps {
  onProductsUpdated?: () => Promise<void>;
}

const useButtonPanel = ({ onProductsUpdated }: UseButtonPanelProps = {}) => {
  const [buttonSelected, setButtonSelected] = useState(0);
  const [isProcessing, setIsProcessing] = useState(false);
  const resolveModalClosedRef = useRef<(() => void) | null>(null);

  const handleModalExited = () => {
    resolveModalClosedRef.current?.();
    resolveModalClosedRef.current = null;
  };

  const waitForModalClose = (): Promise<void> =>
    new Promise<void>((resolve) => {
      resolveModalClosedRef.current = resolve;
      setTimeout(() => {
        if (resolveModalClosedRef.current) {
          resolveModalClosedRef.current = null;
          resolve();
        }
      }, 500);
    });

  //handlers

  const handleButtonSelected = (index: number) => {
    setButtonSelected(index);
  };

  //fin handlers

  // querys
  const deactivateProduct = async (sku: string) => {
    const http = initializeHttpProvider();
    try {
      await http.inventory.updateProduct({ sku: sku, active: false });
      toast.success(`producto ${sku} desactivado con éxito.`);
    } catch {
      toast.error(`Hubo un error al cancelar el producto ${sku}`);
      return;
    }
  };

  const deactivateProducts = async (products: ProductResponse['products']) => {
    setIsProcessing(true);
    try {
      for (const product of products) {
        await deactivateProduct(product.sku);
      }

      setButtonSelected(0);
      await waitForModalClose();

      if (onProductsUpdated) {
        await onProductsUpdated();
      }
    } catch {
      // Individual error handling is in deactivateProduct
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    handleButtonSelected,
    buttonSelected,
    deactivateProducts,
    isProcessing,
    handleModalExited,
  };
};

export default useButtonPanel;
